import * as React from 'react';
import { Page } from '../../components/Page';
import { PaginationContainer } from '../PaginationContainer';
import { ProjectsListContainer } from '../ProjectsListContainer';
import { TitleContainer } from '../TitleContainer';
import { CounterContainer } from '../CounterContainer';
import { PreloaderContainer } from '../PreloaderContainer';
import { FiltersContainer } from '../FiltersContainer';
import { RootLayout } from '../../components/RootLayout';
import { useHistoryListener, useUxfbUserSessionsUpdater } from '../../hooks';
import { Row } from '../../components/Row';
import { Column } from '../../components/Column';
import { BuildersLinkContainer } from '../BuildersLinkContainer';
import { BreadcrumbsContainer } from '../BreadcrumbsContainer';
import { SeoMarkedListContainer } from '../SeoMarkedListContainer';

export function PageContainer() {
  useHistoryListener();
  useUxfbUserSessionsUpdater();

  return (
    <RootLayout>
      <PreloaderContainer />
      <FiltersContainer />
      <Page>
        <BreadcrumbsContainer />
        <TitleContainer />
        <Row>
          <Column marginRight={20}>
            <CounterContainer />
          </Column>
          <Column>
            <BuildersLinkContainer />
          </Column>
        </Row>
        <ProjectsListContainer />
        <PaginationContainer />
        <SeoMarkedListContainer />
      </Page>
    </RootLayout>
  );
}
